import { render } from "./GuestCreateOrder.vue?vue&type=template&id=41132c86"
import script from "./GuestCreateOrder.vue?vue&type=script&lang=js"
export * from "./GuestCreateOrder.vue?vue&type=script&lang=js"

import "./GuestCreateOrder.vue?vue&type=style&index=0&id=41132c86&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__